import { styled, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import MUIList from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import * as React from 'react';


const CustomListItem = styled(ListItem)(({theme})=>({

  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  width: "100%",
  backgroundColor: theme.palette.primary.main,
  paddingLeft: theme.spacing(5.5),
  '&:hover':{
    backgroundColor: theme.palette.primary.dark,
    cursor: "pointer",
    transition: ".3s"
  }

}))

export default function List({items}:{items: {text:string, onClick: ()=>void}[]}) {
  return (
    <Box sx={{ width: '100%', margin: 0 }}>
      <nav>
        {
            items.map((item, index)=>(

                <MUIList
                    disablePadding
                    key={index}
                >
                    <CustomListItem
                        sx={{
                            
                            // paddingX: "1rem"
                        }}
                        onClick={item.onClick}
                    >
                        {/* <ListItemIcon>
                            {item.Icon}
                        </ListItemIcon> */}
                        <Typography
                          fontSize={13}
                        >
                          {item.text}
                        </Typography>
                    
                    </CustomListItem>
                </MUIList>

            ))
        }
      </nav>
    </Box>
  );
}